/**
 * Created by staffanrantzow on 17/03/16.
 */

export const OPEN_MAIN_MENU = 'main-menu:open';
export const CLOSE_MAIN_MENU = 'main-menu:close';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/main-menu/action-types.js
 **/